var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("span", {
      staticClass: "divider",
      style: { borderTop: `solid 1px ${_vm.$themeTokens.fineLine}` },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }